module.exports = __webpack_public_path__ + "img/32.28bbd500.jpg";